import React from "react";

import { formatApiErrorForDisplay } from "helpers/packageManagementApi";
import { Loader, QueryErrorPanel } from "widgets";

import { UPLOAD_HISTORY_COPY } from "../../constants/uploadsContent";
import useUploadHistoryTable from "../../hooks/useUploadHistoryTable";
import UploadHistoryPagination from "./UploadHistoryPagination";
import UploadHistoryTable from "./UploadHistoryTable";
import UploadHistoryToolbar from "./UploadHistoryToolbar";
import styles from "./FileUploadsHistory.module.scss";

const UploadHistoryStatePanel = ({ children }) => (
  <div className={styles.statePanel}>{children}</div>
);

const FileUploadsHistory = ({
  scriptId,
  userId,
  uploadHistory,
  isHistoryLoading,
  isError,
  error,
  onRefetch,
  onDownloadProcessedFile,
  downloadingFileId,
}) => {
  const table = useUploadHistoryTable({ uploadHistory, scriptId });

  const isInitialLoading = isHistoryLoading && uploadHistory === undefined;

  if (isInitialLoading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loadingPanel}>
          <Loader />
        </div>
      </div>
    );
  }

  const renderContent = () => {
    if (!userId) {
      return (
        <UploadHistoryStatePanel>
          <p className={styles.message}>{UPLOAD_HISTORY_COPY.LOGIN_REQUIRED}</p>
        </UploadHistoryStatePanel>
      );
    }

    if (isError) {
      return (
        <UploadHistoryStatePanel>
          <QueryErrorPanel
            message={formatApiErrorForDisplay(
              error,
              UPLOAD_HISTORY_COPY.LOAD_ERROR_FALLBACK
            )}
            onRetry={onRefetch}
          />
        </UploadHistoryStatePanel>
      );
    }

    if (table.filteredRows.length === 0) {
      return (
        <UploadHistoryStatePanel>
          <p className={styles.message}>{UPLOAD_HISTORY_COPY.EMPTY_STATE}</p>
        </UploadHistoryStatePanel>
      );
    }

    return (
      <>
        <UploadHistoryTable
          rows={table.paginatedRows}
          downloadingFileId={downloadingFileId}
          onDownloadProcessedFile={onDownloadProcessedFile}
        />
        <UploadHistoryPagination
          currentPage={table.currentPage}
          totalPages={table.totalPages}
          pageSize={table.pageSize}
          startIndex={table.startIndex}
          endIndex={table.endIndex}
          totalRows={table.filteredRows.length}
          onPreviousPage={table.goToPreviousPage}
          onNextPage={table.goToNextPage}
          onPageChange={table.goToPage}
          onPageSizeChange={table.updatePageSize}
        />
      </>
    );
  };

  return (
    <div className={styles.wrapper}>
      {userId ? (
        <UploadHistoryToolbar
          searchTerm={table.searchTerm}
          statusFilter={table.statusFilter}
          dateRange={table.dateRange}
          onSearchChange={table.updateSearchTerm}
          onStatusFilterChange={table.updateStatusFilter}
          onDateRangeChange={table.updateDateRange}
        />
      ) : null}

      <div className={styles.contentPanel}>{renderContent()}</div>
    </div>
  );
};

export default FileUploadsHistory;
